import { RootState } from '../store';

export const transactionSelector = (state: RootState) => state.transaction;
